import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "errors", "container"]

  async submit(event) {
    event.preventDefault()
    this.renderErrors([])

    const form = this.formTarget
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")

    try {
      const response = await fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          ...(token ? { "X-CSRF-Token": token } : {})
        }
      })

      const payload = await response.json()

      if (response.ok && payload.ok) {
        this.renderSuccess(payload.message || "Thanks! We received your message.")
        this.fireGa4SuccessEvent()
        return
      }

      this.renderErrors(payload.errors || ["Something went wrong. Please try again."])
    } catch (_) {
      this.renderErrors(["We could not submit the form right now. Please try again."])
    }
  }

  renderErrors(errors) {
    if (!this.hasErrorsTarget) return

    if (!errors.length) {
      this.errorsTarget.classList.add("d-none")
      this.errorsTarget.innerHTML = ""
      return
    }

    const list = errors.map((e) => `<li>${this.escapeHtml(e)}</li>`).join("")
    this.errorsTarget.innerHTML = `<strong>Please fix the following:</strong><ul class="mb-0 mt-2">${list}</ul>`
    this.errorsTarget.classList.remove("d-none")
  }

  renderSuccess(message) {
    if (!this.hasContainerTarget) return

    this.containerTarget.innerHTML = `
      <div class="text-center py-3">
        <h3 class="h5 mb-3">Message received</h3>
        <p class="mb-2">${this.escapeHtml(message)}</p>
        <p class="mb-0 text-muted">Our team will get back to you soon.</p>
      </div>
    `
  }

  fireGa4SuccessEvent() {
    window.dataLayer = window.dataLayer || []
    if (typeof gtag === "function") {
      gtag("event", "support_contact_submit", { method: "support_form" })
    } else {
      window.dataLayer.push({ event: "support_contact_submit", method: "support_form" })
    }
  }

  escapeHtml(value) {
    const div = document.createElement("div")
    div.textContent = value || ""
    return div.innerHTML
  }
}
